export default __webpack_public_path__ + "static/media/light-italic.0c40d1be.woff";